package com.islamicmedia.site.pages.isitsafe

import androidx.compose.runtime.Composable
import com.islamicmedia.site.components.PublicReviewPage
import com.varabyte.kobweb.core.Page

/** Public SEO review — "/isitsafe/wall-e". Pulls the REAL cached analysis from PROD. */
@Page("/isitsafe/wall-e")
@Composable
fun WallEReviewPage() {
    PublicReviewPage(
        slug = "wall-e",
        blurb = "Thinking about watching WALL-E with your children? Here's an honest look at it through an Islamic lens: the good, the concerns, and the evidence behind them.",
    )
}
